//==本JS是加载Lodop插件或Web打印服务CLodop/Lodop7的综合示例，可直接使用，建议理解后融入自己程序==

//用双端口加载主JS文件Lodop.js(或CLodopfuncs.js兼容老版本)以防其中某端口被占:
var MainJS = "CLodopfuncs.js",
    URL_WS1 = "ws://localhost:8000/" + MainJS,                //ws用8000/18000
    URL_WS2 = "ws://localhost:18000/" + MainJS,
    URL_HTTP1 = "http://localhost:8000/" + MainJS,              //http用8000/18000
    URL_HTTP2 = "http://localhost:18000/" + MainJS,
    URL_HTTP3 = "https://localhost.lodop.net:8443/" + MainJS   //https用8443

var CreatedOKLodopObject, CLodopIsLocal, LoadJsState

//==判断是否需要CLodop(那些不支持插件的浏览器):==
function needCLodop() {
    try {
        var ua = navigator.userAgent
        if (ua.match(/Windows\sPhone/i) ||
            ua.match(/iPhone|iPod|iPad/i) ||
            ua.match(/Android/i) ||
            ua.match(/Edge\D?\d+/i))
            return true
        var verTrident = ua.match(/Trident\D?\d+/i)
        var verIE = ua.match(/MSIE\D?\d+/i)
        var verOPR = ua.match(/OPR\D?\d+/i)
        var verFF = ua.match(/Firefox\D?\d+/i)
        var x64 = ua.match(/x64/i)
        if ((!verTrident) && (!verIE) && (x64)) return true
        else if (verFF) {
            verFF = verFF[0].match(/\d+/)
            if ((verFF[0] >= 41) || (x64)) return true
        } else if (verOPR) {
            verOPR = verOPR[0].match(/\d+/)
            if (verOPR[0] >= 32) return true
        } else if ((!verTrident) && (!verIE)) {
            var verChrome = ua.match(/Chrome\D?\d+/i)
            if (verChrome) {
                verChrome = verChrome[0].match(/\d+/)
                if (verChrome[0] >= 41) return true
            }
        }
        return false
    } catch (err) {
        return true
    }
}

// 加载 Clodop 主 JS
// HTTP 页：localhost:8000 / 18000
// HTTPS 页：必须用 https://localhost.lodop.net:8443，否则混合内容被拦截，getCLodop 不存在
function loadCLodop() {
    if (LoadJsState == 'loading' || LoadJsState == 'complete') return
    LoadJsState = 'loading'
    var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement
    var isHttps = (window.location.protocol === 'https:')

    function markComplete() {
        LoadJsState = "complete"
    }

    if (isHttps) {
        var JS_HTTPS = document.createElement("script")
        JS_HTTPS.src = URL_HTTP3
        JS_HTTPS.onload = markComplete
        JS_HTTPS.onerror = function () {
            console.warn(
                "[Lodop] HTTPS 加载失败。请确认 C-Lodop 已启动，并先在浏览器打开一次：https://localhost.lodop.net:8443/"
            )
            markComplete()
        }
        head.insertBefore(JS_HTTPS, head.firstChild)
        CLodopIsLocal = true
        return
    }

    var JS1 = document.createElement("script")
    var JS2 = document.createElement("script")
    JS1.src = URL_HTTP1 + "?priority=1"
    JS2.src = URL_HTTP2
    JS1.onload = JS2.onload = markComplete
    JS1.onerror = JS2.onerror = markComplete
    head.insertBefore(JS1, head.firstChild)
    head.insertBefore(JS2, head.firstChild)
    CLodopIsLocal = !!((JS1.src + JS2.src).match(/\/\/localho|\/\/127.0.0./i))
}

if (needCLodop()) { loadCLodop() }

/** 重新加载 CLodop 主 JS（刷新打印机前可调用） */
function reloadCLodop() {
    LoadJsState = null
    loadCLodop()
}

//==获取LODOP对象主过程,判断是否安装、需否升级:==
function getLodop(oOBJECT, oEMBED, silent) {
    var strFontTag = "<br><font class='lodop' color='#FF00FF'>打印控件"
    var strLodopInstall = strFontTag + "未安装!点击这里<a href='install_lodop32.exe' target='_self'>执行安装</a>"
    var strLodopUpdate = strFontTag + "需要升级!点击这里<a href='install_lodop32.exe' target='_self'>执行升级</a>"
    var strLodop64Install = strFontTag + "未安装!点击这里<a href='install_lodop64.exe' target='_self'>执行安装</a>"
    var strLodop64Update = strFontTag + "需要升级!点击这里<a href='install_lodop64.exe' target='_self'>执行升级</a>"
    var strCLodopInstallA = "<br><font color='#FF00FF'>Web打印服务CLodop未安装启动，点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>下载执行安装</a>"
    var strCLodopInstallB = "<br>（若此前已安装过，可<a href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a>）"
    var strCLodopUpdate = "<br><font color='#FF00FF'>Web打印服务CLodop需升级!点击这里<a href='CLodop_Setup_for_Win32NT.exe' target='_self'>执行升级</a>"
    var strLodop7FontTag = "<br><font color='#FF00FF'>Web打印服务Lodop7"
    var strLodop7HrefX86 = "点击这里<a href='Lodop7_Linux_X86_64.tar.gz' target='_self'>下载安装</a>(下载后解压，点击lodop文件开始执行)"
    var strLodop7HrefARM = "点击这里<a href='Lodop7_Linux_ARM64.tar.gz'  target='_self'>下载安装</a>(下载后解压，点击lodop文件开始执行)"
    var strLodop7Install_X86 = strLodop7FontTag + "未安装启动，" + strLodop7HrefX86
    var strLodop7Install_ARM = strLodop7FontTag + "未安装启动，" + strLodop7HrefARM
    var strLodop7Update_X86 = strLodop7FontTag + "需升级，" + strLodop7HrefX86
    var strLodop7Update_ARM = strLodop7FontTag + "需升级，" + strLodop7HrefARM
    var strInstallOK = "，成功后请刷新本页面或重启浏览器。</font>"
    var LODOP
    try {
        var isWinIE = (/MSIE/i.test(navigator.userAgent)) || (/Trident/i.test(navigator.userAgent))
        var isWinIE64 = isWinIE && (/x64/i.test(navigator.userAgent))
        var isLinuxX86 = (/Linux/i.test(navigator.platform)) && (/x86/i.test(navigator.platform))
        var isLinuxARM = (/Linux/i.test(navigator.platform)) && (/aarch/i.test(navigator.platform))

        if (needCLodop() || isLinuxX86 || isLinuxARM) {
            // 若尚未挂上 getCLodop，再尝试加载一次
            if (typeof window.getCLodop !== "function") {
                LoadJsState = null
                loadCLodop()
            }
            try {
                if (typeof window.getCLodop === "function") {
                    LODOP = window.getCLodop()
                }
            } catch (err) { }
            if (!LODOP && LoadJsState !== "complete") {
                if (!LoadJsState)
                    console.log("未曾加载Lodop主JS文件，请先调用loadCLodop过程."); else
                    console.log("网页还没下载完毕，请稍等一下再操作.")
                return
            }
            var strAlertMessage
            if (!LODOP) {
                if (isLinuxX86)
                    strAlertMessage = strLodop7Install_X86
                else if (isLinuxARM)
                    strAlertMessage = strLodop7Install_ARM
                else
                    strAlertMessage = strCLodopInstallA + (CLodopIsLocal ? strCLodopInstallB : "")
                var httpsHint =
                    window.location.protocol === "https:"
                        ? "\nHTTPS 站点请先访问一次：https://localhost.lodop.net:8443/ ，允许证书后再刷新本页。"
                        : ""
                if (!silent) {
                    alert(
                        "Web打印服务CLodop未安装启动(若此前已安装过,可刷新重启),成功后请刷新本页面或重启浏览器。" +
                            httpsHint
                    )
                }
                return
            } else {
                if (isLinuxX86 && LODOP.CVERSION < "7.0.7.5")
                    strAlertMessage = strLodop7Update_X86
                else if (isLinuxARM && LODOP.CVERSION < "7.0.7.5")
                    strAlertMessage = strLodop7Update_ARM
                else if (LODOP.CVERSION && LODOP.CVERSION < "6.5.8.0")
                    strAlertMessage = strCLodopUpdate

                if (strAlertMessage)
                    console.log('Web打印服务CLodop需升级!需升级,成功后请刷新本页面或重启浏览器。')
            }
        } else {
            if (oOBJECT || oEMBED) {
                if (isWinIE)
                    LODOP = oOBJECT
                else
                    LODOP = oEMBED
            } else if (!CreatedOKLodopObject) {
                LODOP = document.createElement("object")
                LODOP.setAttribute("width", 0)
                LODOP.setAttribute("height", 0)
                LODOP.setAttribute("style", "position:absolute;left:0px;top:-100px;width:0px;height:0px;")
                if (isWinIE)
                    LODOP.setAttribute("classid", "clsid:2105C259-1E0C-4534-8141-A753534CB4CA")
                else
                    LODOP.setAttribute("type", "application/x-print-lodop")
                document.documentElement.appendChild(LODOP)
                CreatedOKLodopObject = LODOP
            } else
                LODOP = CreatedOKLodopObject
            if ((!LODOP) || (!LODOP.VERSION)) {
                alert('未安装!请先安装,成功后请刷新本页面或重启浏览器。')
                return LODOP
            }
            if (LODOP.VERSION < "6.2.2.6") {
                console.log('需要升级,请先升级,成功后请刷新本页面或重启浏览器。')
            }
        }
        //===如下空白位置适合调用统一功能(如注册语句、语言选择等):=======================
        LODOP.SET_LICENSES("", "7C1178C142E5DEA53E73C2791D910455040", "", "");

        //===============================================================================
        return LODOP
    } catch (err) {
        if (!silent) {
            alert("getLodop出错:" + err)
        }
    }
}
export { getLodop, reloadCLodop }
